import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconArticle = (props: PropsType) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M11.46 0.5H0V11.5L2.65 8.86H11.46V0.5Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconArticle;
